const FYPF2022_options      = require("./styles/fypf2022/options")
const DOUOB_options         = require("./styles/douob/options")
const LEHMANN_options       = require("./styles/lehmann/options")
const SGPSEEDCARE_options   = require("./styles/sgpseedcare/options")
const BAGO2023_options      = require("./styles/bago2023/options")
const SYNFUN2023_options    = require("./styles/synfun2023/options")
const ADAMA2023_options     = require("./styles/adama2023/options")
const SYNISF2023_options    = require("./styles/synisf2023/options")
const SYNPLAY_ES_options    = require("./styles/SYNPLAY_ES/options")
const WAVE2023_options      = require("./styles/wave2023/options")
const TOM2023_options       = require("./styles/tom2023/options")
const ADIDAS2024_options    = require("./styles/adidas2024/options")
const BNAVISA2024_options   = require("./styles/bnavisa2024/options")
const TCL2024L_options      = require("./styles/tcl2024-libertadores/options")
const TCL2024TCL_options    = require("./styles/tcl2024-tcl/options")


const options = {
    'SGPSEEDCARE': SGPSEEDCARE_options,
    'SYNFIELDVISIT': SGPSEEDCARE_options,
    'DOUOB': DOUOB_options,
    'FYPF2022': FYPF2022_options,
    'LEHMANN': LEHMANN_options,
    'BAGO2023': BAGO2023_options,
    'SYNFUN2023': SYNFUN2023_options,
    'ADAMA2023' : ADAMA2023_options,
    'SYNISF2023' : SYNISF2023_options,
    'SYNPLAY_ES' : SYNPLAY_ES_options,
    'WAVE2023' : WAVE2023_options,
    'TOM2023' : TOM2023_options,
    'ADIDAS2024' : ADIDAS2024_options,
    'BNAVISA2024' : BNAVISA2024_options,
    'TCL2024L' : TCL2024L_options,
    'TCL2024TCL' : TCL2024TCL_options,
}

module.exports = options[process.env.VUE_APP_PRODUCT_THEME]